var parent = require('../../es/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/slice.js
// module id = 229
// module chunks = 0 1